import React, { useEffect, useRef, useState } from "react";
import GroupActivityButton from "../groups/ui/GroupActivityButton";
import CallDetailsSvg from "../../svg/CallDetailsSvg.svg";
import BusinessBagSvg from "../../svg/BusinessBagSvg.svg";
import TimerSolidSvg from "../../svg/TimerSolidSvg.svg";
import { format, formatDistance, parseISO } from "date-fns";
import { ImAttachment, ImStopwatch } from "react-icons/im";
import "./style.css";
import {
  changeDateFormatYYYY,
  getFileExtinsion,
  getFileName,
  getFileType,
  showToastError,
  showToastSuccess,
} from "../../Utils/Helper";
import { IoMdImages } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../header/Navbar";
import Sidebar from "../sidebar/Sidebar";
import AttachmentShowNotes from "./AttachmentShowNotes";
import {
  addAppointmentNote,
  encounterAppointmentNote,
} from "../../services/AppointmentService";
import {
  getUploadFileCategory,
  uploadAppointmentFile,
} from "../../services/FileUploadService";
import moment from "moment-timezone";
import { FaCopy } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Dropdown } from "react-bootstrap";
import { getUpcomingBookingsByDate } from "../../services/DoctorService";
import { useDateTimezone } from "../../Context/DateTimezoneContext";
import DeleteModal from "../../commonComponent/DeleteModal";

function AppointmentNotes() {
  let initialNoteData = {
    title: "",
    description: "",
    image: "",
    video: "",
    document: "",
    documentThumbnail: "",
    videoThumbnail: "",
  };
  const { dashboardDate } = useDateTimezone();
  const navigate = useNavigate();
  const [NoteData, setNoteData] = useState(initialNoteData);
  const inputImageVideoFile = useRef(null);
  const inputDocumentFile = useRef(null);
  const [Duration, setDuration] = useState("");
  const location = useLocation();
  const { appointmentObj } = location.state;
  const [appointmentData, setAppointmentData] = useState();
  console.log(appointmentObj);

  useEffect(() => {
    getTodaysBookingList(changeDateFormatYYYY(dashboardDate)); // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const getDuration = () => {
      const dur =
        appointmentObj?.startTime &&
        appointmentObj?.endTime &&
        formatDistance(
          parseISO(appointmentObj.endTime),
          parseISO(appointmentObj.startTime)
        );
      setDuration(dur);
    };
    getDuration(); // eslint-disable-next-line
  }, []);

  const getTodaysBookingList = async (date) => {
    try {
      const response = await getUpcomingBookingsByDate(date);
      console.log(response.data.data);
      if (response.status === 200) {
        let foundItem = response.data.data.find(
          (item) => item._id === appointmentObj._id
        );
        setAppointmentData(foundItem);
        let sortedArr = [...foundItem?.userNotes].sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );

        handleEdit(sortedArr[0]);
      } else {
        showToastError(response?.data || response.message);
      }
    } catch (error) {
      error?.data?.data &&
        showToastError(error?.data?.data || error.data?.message);
    }
  };

  const uploadFileIfExists = async (
    file,
    category,
    fileName,
    appointmentId
  ) => {
    if (file) {
      await uploadAppointmentFile(file[0], category, fileName, appointmentId);
    }
  };

  const uploadAllFile = async () => {
    const documentName = Array.isArray(NoteData?.document)
      ? getFileName(NoteData?.document[0]) +
        "." +
        getFileExtinsion(NoteData?.document[0])
      : NoteData.document;
    const imageName = Array.isArray(NoteData?.image)
      ? getFileName(NoteData.image[0]) +
        "." +
        getFileExtinsion(NoteData.image[0])
      : NoteData?.image;
    const videoName = Array.isArray(NoteData?.video)
      ? getFileName(NoteData.video[0]) +
        "." +
        getFileExtinsion(NoteData.video[0])
      : NoteData?.video;

    const docthumbnail = `docThumbnail__`;
    const vthumbnail = `videoThumbnail__`;

    const { video, videoThumbnail, image, documentThumbnail, document } =
      NoteData;

    // Assuming videoName, vthumbnail, imageName, docthumbnail, documentName are defined somewhere
    await uploadFileIfExists(
      video,
      getUploadFileCategory.appointmentVideo,
      videoName,
      appointmentObj._id
    );
    await uploadFileIfExists(
      videoThumbnail,
      getUploadFileCategory.appointmentVideo,
      vthumbnail,
      appointmentObj._id
    );
    await uploadFileIfExists(
      image,
      getUploadFileCategory.appointmentImage,
      imageName,
      appointmentObj._id
    );
    await uploadFileIfExists(
      documentThumbnail,
      getUploadFileCategory.appointmentDocument,
      docthumbnail,
      appointmentObj._id
    );
    await uploadFileIfExists(
      document,
      getUploadFileCategory.appointmentDocument,
      documentName,
      appointmentObj._id
    );

    return { documentName, imageName, videoName };
  };

  const handleEdit = (note) => {
    setNoteData({
      title: note.noteTitle,
      description: note.noteDescription,
      image: note.file.image,
      video: note.file.video,
      document: note.file.document,
      documentThumbnail: "",
      videoThumbnail: "",
    });
  };

  const handleFileUploading = async () => {
    const hasFileArray =
      Array.isArray(NoteData.image) ||
      Array.isArray(NoteData.video) ||
      Array.isArray(NoteData.document);

    if (hasFileArray) {
      const response = await uploadAllFile();
      return response;
    }
  };

  const handleSubmit = async (assign = false) => {
    const hasFileArray =
      Array.isArray(NoteData.image) ||
      Array.isArray(NoteData.video) ||
      Array.isArray(NoteData.document);

    const response = await handleFileUploading();
    console.log(response, "ress");

    const { title, description } = NoteData;
    // Check if any required fields are missing
    if (!title || !description) {
      return showToastError("Fill the notes");
    }

    // Preparing formdata
    let parms = {};
    parms["title"] = NoteData.title;
    parms["description"] = NoteData.description;
    parms["appointmentid"] = appointmentObj._id;
    parms["file"] = {
      image: hasFileArray ? response?.imageName : NoteData.image,
      video: hasFileArray ? response?.videoName : NoteData.video,
      document: hasFileArray ? response?.documentName : NoteData.document,
    };

    try {
      const response = await addAppointmentNote(parms);
      if (response.status !== 200) {
        showToastError("Adding Notes failed try again later");
        return;
      }
      showToastSuccess("Note Added");
      if (assign) {
        handleEncounter();
      }
      getTodaysBookingList(changeDateFormatYYYY(dashboardDate));
      setNoteData(initialNoteData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEncounter = async () => {
    let parms = {};
    if (!parms) return;

    const response = await encounterAppointmentNote(parms);

    if (response.status !== 200) {
      showToastError("Encounter notes to individual failed");
      return;
    }

    showToastSuccess("Added to encounter");
  };

  // toggle input file option menu
  const onButtonClick = (e) => {
    // `current` points to the mounted file input element
    if (e.target.id !== "image") {
      inputDocumentFile.current.click();
      // setFileName()
    } else {
      inputImageVideoFile.current.click();
    }
  };

  // set input file according to attachment change
  const onAttachmentChange = (e) => {
    console.log(e.target.files[0]);
    setNoteData({
      ...NoteData,
      image: "",
      video: "",
      document: "",
    });

    if (getFileType(e.target.files[0]) === "image") {
      setNoteData({
        ...NoteData,
        image: [e.target.files[0]],
        video: "",
        document: "",
      });
    } else if (getFileType(e.target.files[0]) === "video") {
      setNoteData({
        ...NoteData,
        image: "",
        video: [e.target.files[0]],
        document: "",
      });
    } else if (getFileType(e.target.files[0]) === "document") {
      setNoteData({
        ...NoteData,
        image: "",
        video: "",
        document: [e.target.files[0]],
      });
    }
  };

  const handleChange = (e) => {
    setNoteData({ ...NoteData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <Navbar />

      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>
          <div className="col-md-10 py-4 px-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li
                  className="breadcrumb-item cursor-pointer"
                  onClick={() => navigate("/")}
                >
                  Home
                </li>
                <li
                  className="breadcrumb-item active fw-bold pointer"
                  aria-current="page"
                  onClick={() => navigate(-1)}
                >
                  Appointments
                </li>
              </ol>
            </nav>
            <h3>View Appointment Notes </h3>
            <p className="resFont">
              {appointmentData?.type === "group"
                ? "Group Appointment"
                : "Individual Appointment"}
            </p>
            <div
              className="d-flex gap-3"
              style={{ height: "auto", minHeight: "1000px" }}
            >
              <div
                className="col-3 p-2 rounded"
                style={{
                  backgroundColor: "rgba(247, 247, 247, 1)",
                }}
              >
                <div className="row mt-2 mb-3">
                  <div className="col-12 fw-bold headFont">Current Session</div>
                  <div
                    className="col-12 my-1 resFont"
                    style={{
                      color: "rgba(47, 156, 149, 1)",
                    }}
                  >
                    {" "}
                    <img
                      src={BusinessBagSvg}
                      alt=""
                      style={{ fontSize: "20px" }}
                    ></img>{" "}
                    {appointmentData?.type === "group"
                      ? "Group Appointment"
                      : "Individual Appointment"}
                  </div>
                  <div className="col-12 my-1 resFont">
                    <img src={CallDetailsSvg} className="pe-3" alt="" />
                    {appointmentData?.bookingType === "video"
                      ? "(Video Call)"
                      : "(By Phone)"}
                  </div>
                  <div className="col-12 my-1">
                    <div className="d-flex align-items-center">
                      <div className="d-flex align-items-center column-gap-2 resFont">
                        {appointmentData?.startTime &&
                          format(
                            parseISO(appointmentData?.startTime),
                            "EEE, MMM d yyyy"
                          )}{" "}
                        {appointmentData?.sessionDate &&
                          format(
                            parseISO(appointmentData?.startTime),
                            "EEE, MMM d, yyyy"
                          )}{" "}
                        <img
                          src={TimerSolidSvg}
                          alt=""
                          style={{ height: "20px", width: "20px" }}
                        />
                        {appointmentData?.startTime &&
                          moment(new Date(appointmentData?.startTime))
                            .tz("America/Chicago")
                            .format("hh:mm")}{" "}
                        CST
                      </div>
                    </div>
                  </div>
                  <div className="col-12 d-flex align-items-center gap-2">
                    Duration : {Duration}{" "}
                    <ImStopwatch
                      style={{
                        color: "rgba(21, 101, 99, 1)",
                        backgroundClip: "content-box",
                      }}
                    />{" "}
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 fw-bold mb-2 headFont">
                    Previous version
                  </div>
                  <div
                    className="Dash col-11 d-flex flex-column align-items-between my-2 "
                    style={{
                      maxHeight: "700px",
                      height: "700px",
                      overflowY: `${
                        appointmentData?.userNotes?.length > 4
                          ? "scroll"
                          : "hidden"
                      }`,
                    }}
                  >
                    {appointmentData?.userNotes &&
                      [...appointmentData?.userNotes]
                        .sort((a, b) => new Date(b.date) - new Date(a.date))
                        .map((note) => {
                          return (
                            <>
                              <div className="d-flex justify-content-around align-items-center my-2">
                                <div
                                  className="icon pointer"
                                  onClick={() => handleEdit(note)}
                                >
                                  <FaCopy />
                                </div>
                                <div
                                  className="d-flex flex-column pointer"
                                  onClick={() => handleEdit(note)}
                                >
                                  <span className="resFont fw-bold ">
                                    {note.noteTitle}
                                  </span>
                                  <span>
                                    {moment(new Date(note.date)).format(
                                      "hh:mm a, MMM DD, yyyy"
                                    )}
                                  </span>
                                </div>
                                <div className="menu">
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="light"
                                      className="custom"
                                      id="dropdown-basic"
                                    >
                                      <BsThreeDotsVertical />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item>Assign to</Dropdown.Item>
                                      <Dropdown.Item>Save as PDF</Dropdown.Item>
                                      <Dropdown.Item>Download</Dropdown.Item>
                                      <Dropdown.Item>Print</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </div>
                            </>
                          );
                        })}
                  </div>
                </div>
              </div>
              <div className="col-9">
                <div style={{ fontSize: "24px" }} className="fw-bold mb-2">
                  Make Note Selection:
                </div>
                <div className=" border-1 border  p-4">
                  <div className="d-flex  flex-column justify-content-between h-100">
                    <div>
                      <div className="d-flex  mb-2 justify-content-start ">
                        <div className="w-25">
                          <div style={{ fontSize: "24px" }} className="fw-bold">
                            Title of Note
                          </div>
                        </div>
                        <div className="w-75">
                          <input
                            type="text"
                            className="p-2 w-100 border-0 rounded"
                            name="title"
                            style={{
                              backgroundColor: "rgba(241, 241, 241, 1)",
                            }}
                            onChange={(e) => handleChange(e)}
                            value={NoteData.title}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <textarea
                          name="description"
                          value={NoteData.description}
                          onChange={(e) => handleChange(e)}
                          id=""
                          placeholder="Write Your Note Here"
                          cols="5"
                          rows="30"
                          className="border-0"
                          maxLength={200}
                          style={{ height: "100%", width: "100%" }}
                        ></textarea>
                      </div>
                      <div className="attachment-container">
                        {(NoteData.image ||
                          NoteData.document ||
                          NoteData.video) && (
                          <AttachmentShowNotes
                            props={NoteData}
                            setNoteData={setNoteData}
                            appointmentId={appointmentObj._id}
                          />
                        )}
                      </div>
                      <div className="border rounded p-3 d-flex justify-content-between align-items-end">
                        <p className="mb-0">
                          {" "}
                          <input
                            type="file"
                            id="document"
                            ref={inputDocumentFile}
                            accept=".pdf, .doc, .docx"
                            style={{ display: "none" }}
                            onChange={(e) => onAttachmentChange(e)}
                          />
                          <span style={{ color: "rgba(87, 87, 87, 0.8)" }}>
                            Attach to your note
                          </span>
                          <input
                            type="file"
                            id="image"
                            ref={inputImageVideoFile}
                            accept="image/*, video/*"
                            style={{ display: "none" }}
                            onChange={(e) => onAttachmentChange(e)}
                          />
                        </p>
                        <div className="d-flex gap-4 justify-content-end align-items-center me-3">
                          <IoMdImages
                            id="image"
                            onClick={(e) => {
                              onButtonClick(e);
                            }}
                            size="1.5em"
                            className="text-success pointer"
                          />
                          <ImAttachment
                            id="document"
                            onClick={(e) => {
                              onButtonClick(e);
                            }}
                            size="1.2em"
                            className="text-primary pointer"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="align-self-end justify-content-end mt-3 ">
                      <GroupActivityButton
                        backgroundColor="rgba(31, 126, 120, 1)"
                        padding="10px 20px"
                        color="white"
                        className="fw-semibold rounded"
                        border="none"
                        toggle="modal"
                        target="#addmodal"
                      >
                        Save Appointment Note
                      </GroupActivityButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteModal
        modalId={"addmodal"}
        button1={"yes"}
        button2={"no"}
        content1={`Do you want to assign updated notes to ${
          appointmentObj?.type === "group" ? "All participants" : "Individuals"
        }? (Yes / No)`}
        onDelete={() => {
          handleSubmit(true);
        }}
        onCancel={() => {
          handleSubmit();
        }}
      />
    </>
  );
}

export default AppointmentNotes;
